import Add from '@mui/icons-material/Add';
import { Box, Grid, Select, Stack, Typography } from '@mui/joy';
import Button from '@mui/joy/Button';
import Option from '@mui/joy/Option';
import { useMemo, useState } from 'react';
import Loader from '../../components/core/Loader';
import { NoData } from '../../components/nodata';
import useTopics from '../../hooks/useTopics';
import { useUser } from '../../hooks/useUser';
import { Topic } from '../../redux/types/topics';
import { TopicCard } from './TopicCard';
import TopicModal from './TopicModal';

function MainTopicsContent() {
  const [showModal, setShowModal] = useState(false);
  const userQuery = useUser();
  const topicsQuery = useTopics();
  const [filter, setFilter] = useState('All topics');

  const handleShowModal = () => {
    setShowModal(!showModal);
  };

  const user = userQuery.data;
  const topics = topicsQuery.data;

  const isAdmin = useMemo(() => {
    return user?.role === 'ADMIN' || user?.role === 'SUPER_ADMIN';
  }, [user]);

  const filteredTopics = useMemo(() => {
    if (!user || !topics) return [];
    switch (filter) {
      case 'My topics':
        return topics.filter((item: Topic) => {
          return item.owner === user._id;
        });
      case 'Followed topics':
        return topics.filter((topic: Topic) => {
          return topic.members.find((member) => member === user._id);
        });
      default:
        return topics;
    }
  }, [topicsQuery.status, filter]);

  if (!userQuery.isSuccess || !topicsQuery.isSuccess) {
    return <Loader />;
  }

  return (
    <>
      <TopicModal handleShowModal={handleShowModal} isOpen={showModal} />
      <Stack spacing={3}>
        <Typography level="h1">Topics</Typography>

        <Stack direction="row" spacing={2}>
          <Box sx={{ maxWidth: '200px' }}>
            <Select
              value={filter}
              onChange={(_, newValue) => setFilter(newValue || 'All topics')}
              variant="outlined"
            >
              <Option value="All topics">Alle Topics</Option>
              <Option value="Followed topics">Volgend</Option>
              <Option value="My topics">Mijn Topics</Option>
            </Select>
          </Box>

          {/* Create button */}
          {isAdmin && (
            <Button
              variant="solid"
              startDecorator={<Add />}
              onClick={handleShowModal}
            >
              Topic aanmaken
            </Button>
          )}
        </Stack>

        {/* No topics placeholder */}
        {!filteredTopics.length && (
          <div className="w-full flex justify-center pt-[150px]">
            <NoData />
          </div>
        )}

        {/* List of topics */}
        <Grid container spacing={2}>
          {filteredTopics?.map((topic: Topic) => {
            return (
              <Grid key={topic._id} xs={12} xl={6}>
                <TopicCard {...topic} />
              </Grid>
            );
          })}
        </Grid>
      </Stack>
    </>
  );
}

export default MainTopicsContent;
